//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            violation: {},
            GLAccount: [],
            selectedGLAccount: null,
            fee: null,
            amount: 0.00,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            }
        };
    },
    created: function created() {
        var $el = this;
        Event.$on('edit-violation', function (item) {
            $el.violation = item;
            $el.$children[0].$data.showSmallModal = true;
            axios.get("/prototype/violation/gl-account-list").then(function (response) {
                $el.GLAccount = response.data;
            });
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('edit-violation');
    },
    mounted: function mounted() {},

    methods: {
        updateViolation: function updateViolation() {
            var _this = this;

            var $el = this;
            var form = document.querySelector('form');
            var formData = new FormData(form);
            formData.append("id", this.violation.id);
            formData.append("fee", this.violation.fee);
            formData.append("amount", this.violation.amount);
            formData.append("gl_code", this.violation.full_name.id ? this.violation.full_name.id : this.violation.gl_code);
            axios.post('/prototype/violation/update-violation', formData).then(function (response) {
                _this.$snotify.success('The violation was updated');
                Event.$emit('violation-updated-list');
                Event.$emit('close-small-modal');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/violation/editViolation.vue
// module id = tud8
// module chunks = 0 1